export default "__VITE_ASSET__CdTCCAr2__"